import StarIcon from "images/star.svg";
import RewardBronze from "images/reward-bronze.svg";
import RewardGold from "images/reward-gold.svg";
import RewardPlatinum from "images/reward-platinum.svg";
import RewardSilver from "images/reward-silver.svg";
import RewardStarter from "images/reward-starter.svg";
import PlatinumInfo from "images/platinum-info.svg";
import BronzeInfo from "images/bronze-info.svg";
import SilverInfo from "images/silver-info.svg";
import GoldInfo from "images/gold-info.svg";
import StarterInfo from "images/starter-info.svg";
import * as FP from "utils/fp-js";

import {
  BRONZE_MAX_PROGRESS,
  GOLD_MAX_PROGRESS,
  SILVER_MAX_PROGRESS,
  STARTER_MAX_PROGRESS,
} from "Dashboard";

export const MobileRewards = ({ progress, userLevel }) => {
  const Image = FP.match(userLevel)
    .on("Platinum", PlatinumInfo)
    .on("Bronze", BronzeInfo)
    .on("Silver", SilverInfo)
    .on("Gold", GoldInfo)
    .otherwise(StarterInfo);

  return (
    <div className="flex-1 rounded-xl gap-2 flex sx:hidden flex-col sm:flex-col md:flex-col lg:flex-col xl:flex-row 2xl:flex-row justify-stretch items-stretch">
      <img src={Image} alt="platinum info" className="w-100" />
      <div className="text-md text-gray-600 mx-4">
        <div className="flex flex-row items-center gap-2 text-lg font-bold text-black">
          <img src={StarIcon} alt="star icon" className="w-6" />
          My Rewards
        </div>
        Your progress is displayed here, keep it up!
      </div>
      <div className="flex flex-row flex-wrap gap-6 mx-4 px-4 py-10 justify-center items-start bg-white shadow-xl rounded-xl">
        <img src={RewardStarter} alt="reward starter" className="w-14" />
        {progress > STARTER_MAX_PROGRESS && (
          <img src={RewardBronze} alt="reward bronze" className="w-14" />
        )}
        {progress > BRONZE_MAX_PROGRESS && (
          <img src={RewardSilver} alt="reward silver" className="w-14" />
        )}
        {progress > SILVER_MAX_PROGRESS && (
          <img src={RewardGold} alt="reward gold" className="w-14" />
        )}
        {progress > GOLD_MAX_PROGRESS && (
          <img src={RewardPlatinum} alt="reward platinum" className="w-14" />
        )}
      </div>
    </div>
  );
};
